<template>
    <y-panel
        class="campaigns-editor-group"
        :title="$t('campaigns.editor.slug.panel')"
    >
        <y-form-field
            v-model="model.slug"
            type="text"
            name="slug"
        />
    </y-panel>
</template>

<script>
    import { YFormField } from '@deps';

    export default {
        name: 'CampaignsSlugPanel',

        components: {
            YFormField,
        },

        props: {
            value: Object,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                model: this.value || {},
            };
        },

        watch: {
            value: {
                /**
                 * Handle watch value
                 *
                 * @param newVal
                 * @param oldVal
                 */
                handler(newVal, oldVal) {
                    if (!this.isEqual(newVal, oldVal)) {
                        this.$set(this, 'model', { ...this.model, ...newVal });
                    }
                },
                deep: true,
            },

            model: {
                /**
                 * Emit input when model changes
                 */
                handler() {
                    this.$emit('input', this.model);
                },
                deep: true,
            },
        },
    };

</script>
